"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Glasses = void 0;

var tslib_1 = require("tslib");

var use_id_1 = require("@hopin-team/use-id");

var react_1 = tslib_1.__importDefault(require("react"));

var Glasses = function Glasses() {
  var filterId = (0, use_id_1.useId)();
  return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement("filter", {
    id: filterId,
    filterUnits: "objectBoundingBox"
  }, react_1.default.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "1 0 0 0 0.4\n     0 1 0 0 0.4\n     0 0 1 0 0.4\n     0 0 0 1 0"
  })), react_1.default.createElement("path", {
    filter: "url(#".concat(filterId, ")"),
    d: "M23.3749 16.6667C23.3749 11.678 22.2702 7.27385 21.4617 4.50068C21.3136 3.56735 20.7651 2.75066 19.9578 2.25949C19.1516 1.76949 18.1739 1.65979 17.2767 1.95729L16.3889 2.25365C15.9304 2.40649 15.6832 2.90229 15.836 3.36079C15.9877 3.81929 16.4789 4.06779 16.942 3.91379L17.8298 3.61742C18.2382 3.48209 18.6826 3.53231 19.0489 3.75514C19.4152 3.97797 19.6637 4.35013 19.7547 4.87979C20.3334 6.88179 21.0427 9.65267 21.3973 12.826C22.6795 13.4992 23.3749 14.7977 23.3749 16.6667Z",
    fill: "currentColor"
  }), react_1.default.createElement("path", {
    filter: "url(#".concat(filterId, ")"),
    d: "M2.60144 12.826C2.95727 9.64564 3.67241 6.85267 4.26741 4.77367C4.33508 4.349 4.58353 3.97797 4.94986 3.75397C5.3162 3.5323 5.76177 3.48209 6.16894 3.61626L7.05676 3.91262C7.51992 4.06546 8.00992 3.81812 8.16276 3.35962C8.31676 2.90112 8.0684 2.40649 7.6099 2.25249L6.72208 1.95612C5.82608 1.65745 4.8483 1.76716 4.04097 2.25832C3.23364 2.74949 2.68525 3.56611 2.56042 4.39327C1.72859 7.27261 0.623856 11.6768 0.623856 16.6655C0.625022 14.7977 1.32044 13.4991 2.60144 12.826Z",
    fill: "currentColor"
  }), react_1.default.createElement("path", {
    filter: "url(#".concat(filterId, ")"),
    d: "M13.4583 16.6667C13.4583 16.4718 13.4828 16.2991 13.4979 16.1159C13.0313 15.9153 12.5285 15.7917 12 15.7917C11.4715 15.7917 10.9687 15.9153 10.5021 16.1159C10.5172 16.2979 10.5417 16.4718 10.5417 16.6667V17.8333C10.5417 17.9652 10.5219 18.0794 10.5149 18.2066C11.2942 17.3864 12.7058 17.3864 13.4851 18.2066C13.4781 18.0806 13.4583 17.9652 13.4583 17.8333V16.6667V16.6667Z",
    fill: "currentColor"
  }), react_1.default.createElement("path", {
    d: "M21.3997 12.826C20.7475 12.483 19.9532 12.2917 19 12.2917H17.8333C15.2072 12.2917 13.6963 13.6531 13.4979 16.1159C13.4828 16.2979 13.4583 16.4718 13.4583 16.6667V17.8333C13.4583 17.9652 13.4781 18.0794 13.4851 18.2066C13.6228 20.7826 15.1442 22.2083 17.8333 22.2083H19C21.821 22.2083 23.375 20.6543 23.375 17.8333V16.6667C23.375 14.7977 22.6795 13.4992 21.3997 12.826Z",
    fill: "currentColor"
  }), react_1.default.createElement("path", {
    d: "M10.5417 16.6667C10.5417 16.4718 10.5172 16.2991 10.5021 16.1159C10.3037 13.6531 8.79283 12.2917 6.16667 12.2917H5C4.048 12.2917 3.25361 12.483 2.60144 12.826C1.32161 13.4992 0.625 14.7977 0.625 16.6667V17.8333C0.625 20.6543 2.179 22.2083 5 22.2083H6.16667C8.85583 22.2083 10.3772 20.7826 10.5149 18.2066C10.5219 18.0806 10.5417 17.9652 10.5417 17.8333V16.6667Z",
    fill: "currentColor"
  }));
};

exports.Glasses = Glasses;